// import SliderArrow from "~/assets/images/icons/slider-arrow.svg?inline";

export default {
  name: "field",

  data() {
    return {
      fieldValue: ""
    };
  },

  props: {
    fieldOptions: {
      type: Object,
      default: () => {}
    }
  },

  mounted: function() {
    if (
      this.fieldOptions.type == "integer" ||
      this.fieldOptions.type == "boolean"
    ) {
      this.fieldOptions.value = JSON.parse(this.fieldOptions.value);
    }
  },

  methods: {},

  components: {}
};
